import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { useNotifications, setRead, markAllRead, NotificationCategory, NotificationItem } from './notificationsStore';

interface Props {
    onClose: () => void;
}

const FILTERS: { label: string; category?: NotificationCategory }[] = [
    { label: 'All' },
    { label: 'Approvals', category: 'approvals' },
    { label: 'Questions', category: 'questions' },
    { label: 'Registry', category: 'registry' },
];

// header bell dropdown: latest 5 for the chosen filter; the full list is /notifications
const NotificationsMenu: React.FC<Props> = ({ onClose }) => {
    const history = useHistory();
    const { items, unreadCount: unread } = useNotifications();
    const [filter, setFilter] = useState(FILTERS[0]);
    const visible = (filter.category ? items.filter(x => x.category === filter.category) : items).slice(0, 5);

    const open = (n: NotificationItem) => {
        setRead(n.id);
        onClose();
        history.push(n.route);
    };

    return <div className="notif-menu">
        <div className="head">
            <strong>Notifications</strong>
            {unread > 0 && <span className="new-badge">{unread} new</span>}
            <button type="button" className="mark-all" onClick={markAllRead} disabled={unread === 0}>Mark all as read</button>
        </div>
        <div className="filters">
            {FILTERS.map(f => <button key={f.label} type="button" className={f === filter ? 'active' : ''} onClick={() => setFilter(f)}>{f.label}</button>)}
        </div>
        <ul>
            {visible.map(n => <li key={n.id} className={n.unread ? 'unread' : ''} onClick={() => open(n)}>
                <div className="text">
                    <div className="title-row"><span className={`title${n.danger ? ' danger' : ''}`}>{n.title}</span><span className="time">{n.shortTime}</span></div>
                    <div className="body">{n.short}</div>
                </div>
                {n.unread && <span className="dot" />}
            </li>)}
            {visible.length === 0 && <li className="empty">No notifications</li>}
        </ul>
        <button type="button" className="see-all" onClick={() => { onClose(); history.push('/notifications'); }}>See all notifications <FiArrowRight /></button>
    </div>;
};

export default NotificationsMenu;
